<template>
    <off-on-schedule-button v-if="type === 'offOnSchedule'" v-bind:value.sync="parameterValue"></off-on-schedule-button>

    <heat-cool v-else-if="type === 'mode'" v-bind:value.sync="parameterValue"></heat-cool>

    <thermostat-slider v-else-if="type === 'setpoint' && fahrenheitModeActive && isFahrenheitParameter" :module-number="moduleNumber"
                       v-bind:value.sync="parameterValue" :min="fmin" :max="fmax" :unit="'fahrenheit'">
    </thermostat-slider>

    <thermostat-slider v-else-if="type === 'setpoint'" :module-number="moduleNumber" v-bind:value.sync="parameterValue" :min="min" :max="max"
                       :unit="'celsius'">
    </thermostat-slider>
</template>

<script>
    import {mapGetters} from 'vuex';
    import OffOnScheduleButton from "./OffOnScheduleButton";
    import HeatCool from "./HeatCool";
    import ThermostatSlider from "./ThermostatSlider";

    export default {
        name: "InfoParameter",

        components: {
            OffOnScheduleButton,
            HeatCool,
            ThermostatSlider
        },

        props: [
            'moduleNumber',
            'parameterKey',
            'value',
            'type',
            'min',
            'max',
            'fmin',
            'fmax'
        ],

        computed: {
            ...mapGetters({
                getParameters: 'virtualDevice/parameters'
            }),

            parameters: function () {
                return this.getParameters(this.$route.params.id);
            },

            parameterValue: {
                get: function () {
                    return this.value;
                },

                set: function (value) {
                    this.$emit('update:value', value)
                }
            },

            fahrenheitModeActive() {
                return this.parameters.p_186.value == 1;
            },

            isFahrenheitParameter() {
                return this.fmin;
            }
        }
    }
</script>

<style scoped>
</style>